import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@chakra-ui/react';
import { SharedIconCheck } from '../../../shared/icons';

export const CalculatorHomeValueCtaResult: FunctionComponent = () => {
  return (
    <div className={`md:mr-5`}>
      <h2 className={`mb-0 md:mb-8`}>
        <FormattedMessage id={`ctaResult.header.title`} defaultMessage={`Meer weten?`} />
      </h2>
      <p className={`my-8`}>
        <FormattedMessage
          id={`ctaResult.header.description`}
          defaultMessage={`Onze Woningwaardemeter geeft een schatting van de waarde van een woning. Maak vrijblijvend
        een afspraak met een van onze hypotheekadviseurs om meer te weten te komen over je
        mogelijkheden.`}
        />
      </p>
      <ul className={`mb-4 list-none`}>
        <li className={`mb-4`}>
          <SharedIconCheck color={`green.500`} boxSize={`8`} className={`mr-2`} />
          <FormattedMessage
            id={`ctaResult.perks.financial`}
            defaultMessage={`Inzicht in je financiële mogelijkheden`}
          />
        </li>
        <li className={`mb-4`}>
          <SharedIconCheck color={`green.500`} boxSize={`8`} className={`mr-2`} />
          <FormattedMessage
            id={`ctaResult.perks.independent`}
            defaultMessage={`100% onafhankelijk hypotheekadvies`}
          />
        </li>
        <li className={`mb-4`}>
          <SharedIconCheck color={`green.500`} boxSize={`8`} className={`mr-2`} />
          <FormattedMessage
            id={`ctaResult.perks.online`}
            defaultMessage={`Telefonisch, via een online adviesgesprek of op de vestiging`}
          />
        </li>
      </ul>
      <Button
        colorScheme={`orange`}
        as={`a`}
        href={`/afspraak-maken-hypotheekadviseur?ref=woningwaarde`}>
        <FormattedMessage
          id={`ctaResult.appointment.possibilities.label`}
          defaultMessage={`Afspraak maken`}
        />
      </Button>
    </div>
  );
};
